import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { TYPE_META } from "@/lib/videos";

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const meta = TYPE_META[video.type];

  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors duration-300"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - ${meta.label} - 密桃视频`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/5 to-transparent"></div>
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50 whitespace-nowrap">
          <i className={`${meta.icon} text-xs`}></i>
          {meta.label}
        </span>
        <span className="absolute top-2 right-2 rounded-md bg-black/55 px-2 py-0.5 text-xs font-semibold text-primary-100">
          {video.score.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 inline-flex items-center gap-1 text-xs text-background-50/90">
          <i className="ri-time-line text-xs"></i>
          {video.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-[15px] font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
          主演：{video.actors.join("、")}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
          <span className="truncate">{video.genres.slice(0, 2).join(" · ")}</span>
          <span className="ml-auto shrink-0">{video.year}</span>
        </div>
      </div>
    </Link>
  );
}